import { type RefSelectProps, Select } from 'antd'
import clsx from 'clsx'
import { forwardRef, type Ref } from 'react'

import { type SingleOrMultipleSelectProps } from '@/components/types'
import { STATUSES } from '@/constants/common/message.constants'
import {
  type ContractTypeWithError,
  CONTRACT_TYPE_WITH_ERROR_LABEL,
  CONTRACT_TYPE_WITH_ERROR_SELECTABLE
} from '@/libs/api/types'
import { useSelectOnChangeHandler } from '@/libs/hooks'

type Props = SingleOrMultipleSelectProps<
  ContractTypeWithError,
  ContractTypeWithErrorOption
>

export type ContractTypeWithErrorOption = {
  label: string
  value: ContractTypeWithError
}

/**
 * 契約種別を選択するSelect（エラーの選択肢を選択可能）
 */
export const ContractTypeWithErrorSelect = forwardRef(
  (
    {
      className,
      placeholder = STATUSES.UNSELECTED,
      value,
      mode,
      onChange,
      ...props
    }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    // 個建は #5551 で入口を閉じたため選択肢に出さない（CONTRACT_TYPE_WITH_ERROR_SELECTABLE 参照）
    const options: ContractTypeWithErrorOption[] =
      CONTRACT_TYPE_WITH_ERROR_SELECTABLE.map((type) => ({
        label: CONTRACT_TYPE_WITH_ERROR_LABEL[type],
        value: type
      }))
    const handleChange = useSelectOnChangeHandler({ mode, onChange })

    return (
      <Select
        ref={ref}
        {...props}
        mode={mode}
        value={value}
        onChange={handleChange}
        className={clsx(['min-w-[140px]', className])}
        options={options}
        placeholder={placeholder}
      />
    )
  }
)
